// extracted by mini-css-extract-plugin
export default {"container":"EmptyState_container__dW18J","tiny":"EmptyState_tiny__KEHP9","text":"EmptyState_text__qeNsU","img":"EmptyState_img__JPXyh"};